// Small optimized versions of the Lume avatar (the original PNG is 2.3 MB).
export default function LumeAvatar({ size = 28 }) {
  return (
    <picture style={{ display: "contents" }}>
      <source srcSet="/brand/lume-avatar-v2.webp" type="image/webp" />
      <img src="/brand/lume-avatar-v2.png" alt="" aria-hidden="true" width={size} height={size} decoding="async" className="lume-avatar" style={{ width: size, height: size }} />
    </picture>
  );
}
